import { theme } from 'pcln-design-system'
import { useMediaQuery } from 'react-responsive'
import StyledWrapper from '../TripActivity.styled'
import {
  fireFlightRecentSearchViewAllButtonClick,
  fireFlightsOnContinueClickEvent,
  fireOnBookABundleCheckboxClick,
} from '../ga4'
import type { PackageTypeCode, RecentFlightSearches } from '../types'
import BundleHug from './BundleHug'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import ViewAllActivityButton from './ViewAllAcitvityButton'
import transformRecentSearchTripData from './transformRecentSearchTripData'

function onBookABundleClickAndOpen(packageTypeCode: PackageTypeCode, listingsUrl: string) {
  fireOnBookABundleCheckboxClick(packageTypeCode)

  window.open(listingsUrl)
}

export default function FlightsTripActivity({
  mostRecentFlightSearchData,
}: {
  mostRecentFlightSearchData: ReadonlyArray<RecentFlightSearches>
}) {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${theme.breakpoints.lg as string})`,
  })

  const searchData = transformRecentSearchTripData(mostRecentFlightSearchData)

  return (
    <section>
      <StyledWrapper borderRadius='2xl' bg='primary.light' mb='30px'>
        <FlightsRecentSearchCard
          searchData={searchData}
          onContinueSearchClick={fireFlightsOnContinueClickEvent}
        >
          <BundleHug
            onBookABundleClick={(packageTypeCode) => {
              const { listingsUrl } = searchData
              onBookABundleClickAndOpen(packageTypeCode, listingsUrl)
            }}
          />
        </FlightsRecentSearchCard>

        {!isDesktop && (
          <ViewAllActivityButton
            onClick={() => {
              fireFlightRecentSearchViewAllButtonClick()
              window.open('/next-profile/trips?tab=recent_activity')
            }}
          />
        )}
      </StyledWrapper>
    </section>
  )
}
